"use client";

// ClientErrorSetup wires up browser-level error listeners that React/Next.js
// don't catch automatically: unhandled Promise rejections and uncaught errors.
// Renders nothing — mount once at the root layout.

import { useEffect } from "react";
import { logger } from "@/lib/logger";

export function ClientErrorSetup() {
  useEffect(() => {
    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      const error =
        event.reason instanceof Error
          ? event.reason
          : new Error(String(event.reason ?? "Unhandled promise rejection"));
      logger.error(error, { component: "unhandled_rejection" });
    };

    const onUncaughtError = (event: ErrorEvent) => {
      const error = event.error instanceof Error ? event.error : new Error(event.message);
      logger.error(error, { component: "uncaught_error" });
    };

    window.addEventListener("unhandledrejection", onUnhandledRejection);
    window.addEventListener("error", onUncaughtError);

    return () => {
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
      window.removeEventListener("error", onUncaughtError);
    };
  }, []);

  return null;
}
